import styled from "styled-components";

export const GenrealInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
`;

export const Title = styled.h2`
  color: #00aeea;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  padding-top: 10px
  line-height: 1;
  margin-top: 3px;
  font-weight: bold !important;
  padding-left: 10px;
  justify-self: auto;
`;

export const SubTitle = styled.div`
  justify-self: auto;
  color: ${(props) => props.color ?? "#004c7f"};
  font-size: 14px;
  font-weight: 400;
  padding-left: ${(props) => props.paddingLeft ?? "20px"};
  padding-right: 1.375rem;
  margin-bottom: ${(props) => props.marginBottom ?? "20px"};
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
  font-weight: normal;
`;

export const DescriptionData = styled.div`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
  padding-left: 30px;
  padding-right: 30px;
  margin-top: 5px;
  margin-bottom: 15px;
  font-size: 14px;
  font-family: lato;
  font-style: normal;
`;

export const AddressInfo = styled.div`
  justify-self: auto;
  color: #767676;
  font-size: 14px;
  font-weight: bold !important;
  padding-left: 42px;
`;

export const AddressRow = styled.div`
  display: block;
  align-items: center;
`;

export const MarginBottom = styled.div`
  margin-bottom: 30px;
`;

export const MapContainer = styled.div`
  border-radius: 4px;
  position: relative;
  height: 300px;
  overflow: hidden;
  outline: none;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  margin: 0 1.375rem;
  width: 195%;
  border: solid 1px #00aeea;
`;
